<template>
  <div class="tips">尊敬的会员您好，若要下分，请在牌局结束后返回大厅再进行下分操作。</div>
</template>

<script>
export default {
  name: "tips",
  data() {
    return {
      pos: {
        left: 0,
        top: 0,
      },
    };
  },
  mounted() {},
  methods: {
    destory() {
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
      this.$destroy(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  position: fixed;
  z-index: 9999999;
  color: #ffffff;
  font-size: 0.1rem;
  width: max-content;
}
@media all and (orientation: landscape) {
  .tips {
    bottom: 0.15rem;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media all and (orientation: portrait) {
  .tips {
    top: 50%;
    left: 0.15rem;
    transform: translate(-50%, -50%) rotate(90deg);
  }
}
</style>